


























































































































import moment from 'moment';
import Vue from 'vue';
import { fetchConfiguracionStreamax } from './../fetchConfiguracionStreamax';
import { AxiosVue } from '@/AxiosVue'; //
import { LoadingService } from '@/services/loadingService';
import { ServicioProxy } from '@/config/enums'; //
import { Component, Prop } from 'vue-property-decorator';
import { Funcionalidades } from '@/config/funcionalidades';
import { EstadoEntidad } from '@/config/enums';
import Confirmation from '@/components/Confirmation.vue'; //
import { TranslateResult } from 'vue-i18n';
import { GridApi } from 'ag-grid-community';
import { consoleSandbox } from '@sentry/utils';
@Component({
  components: {
    'app-confirmacion': Confirmation,
  },
})
export default class FormEditarRegistInfoStreamax extends Vue {
  @Prop({ default: false }) edited!: any;
  @Prop({ default: false }) esEdicion!: boolean;
  @Prop({ default: {} }) selectedValue: any;
  @Prop({ default: {} }) usuario: any;
  accion!: any;
  ordesList2: any;
  data: any = {};
  rules = {
    required: (value: any) => !!value || 'Required.',
    counter: (value: any) => value.length <= 15 || 'Maximo 15 caracteres',
    soloLetras: (value: any) => {
      return value.match(/^[a-zA-Z]*$/) || 'Solo se permiten letras';
    },
    soloNumeros: (value: any) => {
      return value.match(/^[0-9]*$/) || 'Solo se permiten letras';
    },
    email: (value: any) => {
      if (value != '') {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Invalid e-mail.';
      }
    },
  };
  async getRegistInfoStreamax() {
    let self = this;
    this.loadingService.showLoading();
    return fetchConfiguracionStreamax(
      { id_camara: this.selectedValue },
      'configCamaras/getConfCamaraRegistInfoStreamax'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.loadingService.hideLoading();
          return data.data.data.LISTA;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          this.loadingService.hideLoading();
          return [];
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
        this.loadingService.hideLoading();
      });
  }
  async getRegistInfo() {
    this.ordesList2 = (await this.getRegistInfoStreamax()) || [];
    this.data = this.ordesList2[0];
    let serialnumber = this.data.dsno;
    this.formFields.serialNumber.value =
      this.data.dsno !== ''
        ? JSON.parse(serialnumber.replace(/'/g, '"'))
        : this.data['?column?'].DSNO;
    this.formFields.deviceId.value = this.data['?column?'].AUTOCAR;
    this.formFields.vehicleNum.value = this.data['?column?'].AUTONO;
    console.log(this.formFields.deviceId.value);
    console.log(this.formFields.vehicleNum.value);
    console.log(this.formFields.serialNumber.value);
  }
  mounted() {
    this.getRegistInfo();
  }
  formFields: {
    serialNumber: any;
    deviceId: any;
    vehiclePlate: any;
    vehicleNum: any;
    lineNumber: any;
    driverNumber: any;
    driverName: any;
  } = {
    serialNumber: {
      label: 'Serial Number',
      value: '',
    },
    deviceId: {
      label: 'Device Id',
      value: '',
    },
    vehiclePlate: {
      label: 'Vehicle Plate',
      value: '',
    },
    vehicleNum: {
      label: 'Vehicle Num',
      value: '',
    },
    lineNumber: {
      label: 'Line Number',
      value: '',
    },
    driverNumber: {
      label: 'Driver Number',
      value: '',
    },
    driverName: {
      label: 'Driver Name',
      value: '',
    },
  };
  //abstract
  readonly funcionalidad: Funcionalidades = Funcionalidades.Streamax;
  //propiedades globales
  loadingService = new LoadingService();
  gridApi: GridApi;
  $snotify: any;
  dialog: boolean = true;
  dialogConfirmacionClose: boolean = false;
  bottomNav: any = '1';
  dictionaryFormErrors: any = {};
  validForm: boolean = false;
  dialogConfirmacion: boolean = false;
  btnBloquear: Boolean = false;
  //Interface
  estadoSwitch: boolean = false;
  //controllers
  readonly controller: string = 'funcionalidad';
  readonly controllerAccion: string = 'accion';
  readonly controllerModuloAccion: string = 'moduloaccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);
}
